import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
  FaWhatsapp,
  FaTiktok,
  FaYoutube,
  FaXTwitter,
} from "react-icons/fa6";

function Footer() {
  return (
    <footer className="border-t border-cyan-400/20 bg-black px-6 py-14 text-slate-950 transition-colors duration-300 ">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-4">
        <div>
         <Link to="/" className="flex items-center gap-2 sm:gap-3">
 <img
  src="/logo3.png"
  alt="Eiffeltech Logo"
  className="h-17 sm:h-24 w-auto object-contain"
/>

  <div className="leading-tight">
    
  </div>
</Link>

          <p className="mt-5 text-sm leading-7 text-white">
            Building secure, modern and intelligent digital systems for
            businesses, schools and institutions.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <SocialIcon href="https://wa.me/263716292923" icon={<FaWhatsapp />} />
            <SocialIcon href="https://facebook.com/eiffeltech" icon={<FaFacebookF />} />
            <SocialIcon href="https://instagram.com/eiffeltech" icon={<FaInstagram />} />
            <SocialIcon href="https://linkedin.com/company/eiffeltech" icon={<FaLinkedinIn />} />
            <SocialIcon href="https://github.com/eiffeltech" icon={<FaGithub />} />
            <SocialIcon href="https://tiktok.com/@eiffeltech" icon={<FaTiktok />} />
            <SocialIcon href="https://youtube.com/@eiffeltech" icon={<FaYoutube />} />
            <SocialIcon href="https://x.com/eiffeltech" icon={<FaXTwitter />} />
          </div>
        </div>

        <div>
          <h3 className="font-bold text-slate-950">Company</h3>
          <FooterLink to="/about" text="About" />
          <FooterLink to="/services" text="Services" />
          <FooterLink to="/projects" text="Projects" />
          <FooterLink to="/team" text="Team" />
          <FooterLink to="/contact" text="Contact" />
        </div>

        <div>
          <h3 className="font-bold text-slate-950">Services</h3>
          <FooterLink to="/services" text="Web Development" />
          <FooterLink to="/services" text="Software Systems" />
          <FooterLink to="/services" text="Mobile Applications" />
          <FooterLink to="/services" text="AI Solutions" />
          <FooterLink to="/services" text="Secure Platforms" />
        </div>

        <div>
          <h3 className="font-bold text-slate-950">Contact</h3>

          <a
            href="tel:+263785303423"
            className="mt-3 flex items-center gap-2 text-sm text-white hover:text-cyan-500"
          >
            <Phone size={16} /> +263716292923
          </a>

          <a
            href="mailto:eiffel1@eiffeltech.co.zw"
            className="mt-3 flex items-center gap-2 text-sm text-white hover:text-cyan-500"
          >
            <Mail size={16} /> info@eiffeltech.co.zw 
          </a>

          <p className="mt-3 flex items-center gap-2 text-sm text-white">
            <MapPin size={16} /> Zimbabwe
          </p>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col items-center justify-between gap-4 border-t border-cyan-400/20 pt-6 text-sm text-cyan-400">
        <p>© {new Date().getFullYear()} Eiffeltech. All rights reserved.</p>
        <p>Powered by Eiffeltech Digital Solutions</p>
      </div>
    </footer>
  );
}

function FooterLink({ to, text }) {
  return (
    <Link
      to={to}
      className="mt-3 block text-sm text-white hover:text-cyan-500"
    >
      {text}
    </Link>
  );
}

function SocialIcon({ href, icon }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-10 w-10 items-center justify-center rounded-full border border-cyan-400/30 text-white transition hover:-translate-y-1 hover:border-cyan-400 hover:bg-cyan-400 hover:text-slate-950"
    >
      {icon}
    </a>
  );
}

export default Footer;
